import {AsyncPipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from '@angular/material/tooltip';
import {Router} from '@angular/router';
import {AssetService} from '@app/asset';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {Stream} from '../models';
import {StreamService} from '../stream.service';

@Component({
    selector: 'frog-stream-menu',
    templateUrl: './stream-menu.component.html',
    styleUrls: ['./stream-menu.component.scss'],
    imports: [MatButton, MatTooltip, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, AsyncPipe],
})
export class StreamMenuComponent implements OnInit {
    @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

    public streams$: Observable<Stream[]>;
    public stream$: Observable<Stream>;

    constructor(
        private streamService: StreamService,
        private assetService: AssetService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.streams$ = this.streamService.streams.pipe(
            map((streams) => streams.filter((stream) => stream.parent === null)),
            map((streams) => streams.sort((a, b) => a.name.localeCompare(b.name))),
        );
        this.stream$ = this.streamService.stream;
    }

    viewStream(stream: Stream) {
        this.menuTrigger.closeMenu();
        this.router.navigate([`/s/${stream.id}`]);
    }
}
